import React from 'react';
import { Link } from 'react-router-dom';

/* Logotipo: el «=»: cada cosa a su precio y el nombre. */
export default function Logo({ onNavy = false, label }) {
  return (
    <Link to="/" className={`logo${onNavy ? ' on-navy' : ''}`} aria-label={label}>
      <span className="logo-mark" aria-hidden="true" />
      qyntix
    </Link>
  );
}
